import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog.js';
import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { logout } from '@adornis/users/client/loginFunctions.js';
import { html, nothing } from 'lit';
import * as m from '../../../localization/out/messages.js';
import { LanguageToggle } from './language-toggle.js';
// import * as m from '../../../../localization/out/messages.js';

// Small toolbar with user-level controls shown on embed pages
// - Language switcher
// - Logout button
export const UserToolbar = stateful(() => {
  const user = useObservable(() => currentUser<User>(), []);
  return html`
    <div class="flex items-center gap-2">
      ${LanguageToggle()}
      ${user
        ? html` <button
            class="btn btn-ghost btn-square"
            @click=${async () => {
              const confirm = await XNativeDialog.confirm(m.logout_question(), {
                acceptText: m.logout(),
                declineText: m.cancel(),
              });
              if (confirm) {
                await logout();
                goTo('/');
              }
            }}
          >
            <span class="icon-[material-symbols--logout]"></span>
          </button>`
        : nothing}
    </div>
  `;
});
